<template>
  <div>
    <div class="cont">
      <div class="title">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>工程概况</el-breadcrumb-item>
          <el-breadcrumb-item>项目概况</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="box">
        <div class="box-l">
          <el-tree :data="dataTree" ref="tree" :props="defaultProps" @node-click="handleNodeClick" node-key='id'
          highlight-current default-expand-all>
          <span class="span-ellipsis" slot-scope="{ node, data }"
            style="width: 100%;text-align: left;white-space: nowrap;text-overflow: ellipsis;overflow: hidden;">
            <span :title="node.label" class="">{{data.name}}</span>
          </span>
        </el-tree>
        </div>
        <div class="box-r">
          <div class="box-r-title" style="display: flex;justify-content: space-between;">
            <!-- {{tableData.projectName || '' + '(' + (tableData.projectTypeName || '')+ ')'}} -->
            <div>
              <span>{{tableData.projectName}}</span>
              <span>({{tableData.projectTypeName}})</span>
            </div>

            <div style="font-weight: 900;">
              <span v-if="tableData.projectStatus == 1" style="color: yellow">{{tableData.projectStatusName}}</span>
              <span v-else-if="tableData.projectStatus == 2" style="color: green">{{tableData.projectStatusName}}</span>
              <span v-else-if="tableData.projectStatus == 3" style="color: gray">{{tableData.projectStatusName}}</span>
              <span v-else-if="tableData.projectStatus == 4" style="color: red">{{tableData.projectStatusName}}</span>
            </div>
         
          </div>
          <div class="box-r-t" v-show="projectId">
            <div class="box-r-t-l">
              <img v-if="bigImgUrl" style="height:100%;width:100%" :src="httpCtx + bigImgUrl + '?t=' + new Date().getTime()">
              <div v-else style="height:100%;width:100%"></div>
              <div class="box-r-t-l-title">
                 <el-cascader
                    v-model="value"
                    :options="imgList"
                    @change="handleChange">
                  </el-cascader>
                <!-- <el-select @change="imgChange" v-model="value" placeholder="请选择">
                  <el-option
                    v-for="item in seleList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select> -->
              </div>
            </div>
            <div class="box-r-t-r">
              <div class="row">
                <div>建设单位：</div>
                <div>{{tableData.developmentOrganization}}</div>
              </div>
              <div class="row">
                <div>设计单位：</div>
                <div>{{tableData.designOrganization}}</div>
              </div>
              <div class="row">
                <div>勘察单位：</div>
                <div>{{tableData.explorationOrganization}}</div>
              </div>
              <div class="row">
                <div>施工单位：</div>
                <div>{{tableData.constructionOrganization}}</div>
              </div>
              <div class="row">
                <div>监理单位：</div>
                <div>{{tableData.supervisingOrganization}}</div>
              </div>
              <div class="row">
                <div>建设平方：</div>
                <div>{{tableData.areas}}平方</div>
              </div>
              <div class="row">
                <div>施工许可证：</div>
                <div>{{tableData.permit}}</div>
              </div>
              <div class="row">
                <div>合同价格：</div>
                <div>{{tableData.price}}万元</div>
              </div>
              <div class="row">
                <div>合同开工日期：</div>
                <div>{{tableData.startDate}}</div>
              </div>
              <div class="row">
                <div>合同竣工日期：</div>
                <div>{{tableData.endDate}}</div>
              </div>
              <div class="row">
                <div>合同工期：</div>
                <div>{{tableData.contractPeriod}}天</div>
              </div>
              <div class="row">
                <div>四证一书：</div>
                <div v-if="tableData.fourCertificateBook=='[]'||tableData.fourCertificateBook==''">暂无</div>
                <div class="btn" v-else-if="tableData.fourCertificateBook!='[]'" @click="isShow(tableData.fourCertificateBook)">查看</div>
              </div>
              <div class="row">
                <div>项目计划进度表：</div>
                <div v-if="tableData.scheduleDiagram=='[]'||tableData.scheduleDiagram==''">暂无</div>
                <div class="btn" v-else-if="tableData.scheduleDiagram!='[]'" @click="isShow(tableData.scheduleDiagram)">查看</div>
              </div>
              <div class="row">
                <div>项目地址：</div>
                <div>{{tableData.address}}</div>
              </div>
            </div>
          </div>
          <div  class="box-r-b">
            <div class="box-r-b-t">项目介绍</div>
            <div class="box-r-b-b">
              {{tableData.description}}
            </div>
          </div>
          <!-- 弹窗 -->
          <el-dialog
            :visible.sync="dialogVisible"
            width="30%"
            >
            <el-table
              :data="tableDataList"
              style="width: 100%">
              <el-table-column
                prop="name"
                label="文件名称"
                >
              </el-table-column>
              <el-table-column
                label="操作"
                width="140"
                >
                <template slot-scope="scope">
                  <div class="h-flex">
                    <div class="btn" @click="showFile(scope.row)">预览</div>
                    <div class="btn" @click="downLoad(scope.row)">下载</div>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </el-dialog>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import util from '../../untils/util'
import myHttp from '../../untils/port'
import base from '../../untils/base'
  export default {
    data() {
      return {
        groupId: '',
        projectId: '',
        dataTree: [],
        imgUrl: '',
        imgList: [],
        value: '',
        bigImgUrl: '',
        httpCtx: base.httpCtx,


         tableData: {},
         defaultProps: {
          children: 'children',
          label: 'name'
        },
          dialogVisible:false,
          form:{
            activeName:'',
            parentId:'',
            createBy:util.session.get('user').id,
            groupId:util.session.get('groupId')
          },
          options:[
            {
              label:'第一级',
              value:'111000111',
              children:[
                {
                  label:'第一级2ji',
                  value:'1110001112',
                }
              ]
            }
          ],
          list:[],
          listItemId:'',
          activeName:'',
           currentNodekey: '', //默认选中的节点树
          expandedkeys: [], //默认展开的节点树
          value:"项目效果图",
          seleList:[],
          imgUrl:'',
          dialogVisible:false,
          tableDataList:[]
      }
    },

    created() {
      this.groupId = util.session.get('groupId')  
    },

    mounted(){
      // this.getList()
      this.getTreeData()
    },
    methods:{

      getTreeData() {
        var that = this
        myHttp.findOfficeTreeList({
          entId: this.groupId,
          projectStatus:3
        }).then(function (resp) {
          if (resp.data.code == '200') {
            var list = resp.data.data || []
            var curKey = ''
            var projectId = ''
            if (list.length > 0) {
              curKey = list[0].children[0].id
              that.dataTree = list
              that.projectId = curKey
              that.getData()
            } else {

            }
            setTimeout(function () {
              that.$refs.tree.setCurrentKey(curKey)
            }, 100)
          }
        })
      },

      getData() {
        myHttp.findProjectDetails({
          projectId: this.projectId
        }).then(res => {
          if(res.data.code === 200) {
            const data = res.data.data.project
            

            if(data.photoPath && data.photoPath != '') {
              let photoPath = data.photoPath.split(',')

              let obj = {
                label: '项目效果图',
                value: '项目效果图',
                children: []
              }
              for(let i=0;i<photoPath.length;i++){
                let obj1 = {}
                obj1.label = photoPath[i]
                obj1.value = photoPath[i]
                obj.children.push(obj1)
              }
              this.imgList.push(obj)
            }
            
            if(data.siteSafetySigns) {
               let siteSafetySigns = JSON.parse(data.siteSafetySigns)
              if(siteSafetySigns.length != 0) {
                let obj = {
                  label: '现场安全标志平面布置图',
                  value: '现场安全标志平面布置图',
                  children: []
                }
                for(let i=0;i<siteSafetySigns.length;i++){
                  let obj1 = {}
                  obj1.label = siteSafetySigns[i].name
                  obj1.value = siteSafetySigns[i].fileUrl
                  obj.children.push(obj1)
                }
                this.imgList.push(obj)
              }
            }

            if(data.generalPlan) {
              let generalPlan = JSON.parse(data.generalPlan)
              if(generalPlan.length != 0) {
                let obj = {
                  label: '项目总平面布置图',
                  value: '项目总平面布置图',
                  children: []
                }
                for(let i=0;i<generalPlan.length;i++){
                  let obj1 = {}
                  obj1.label = generalPlan[i].name
                  obj1.value = generalPlan[i].fileUrl
                  obj.children.push(obj1)
                }
                this.imgList.push(obj)
              }
            }

            if(data.temporaryElectrical) {
              let temporaryElectrical = JSON.parse(data.temporaryElectrical)
              if(temporaryElectrical.length != 0) {
                let obj = {
                  label: '现场临时用电平面布置图',
                  value: '现场临时用电平面布置图',
                  children: []
                }
                for(let i=0;i<temporaryElectrical.length;i++){
                  let obj1 = {}
                  obj1.label = temporaryElectrical[i].name
                  obj1.value = temporaryElectrical[i].fileUrl
                  obj.children.push(obj1)
                }
                this.imgList.push(obj)
                if(this.imgList.length != 0) {
                  this.value = this.imgList[0].value
                  this.bigImgUrl = this.imgList[0].children[0].value
                }
              }
            }
           
            this.tableData = data

          }
        })
      },

       handleChange(value) {
        this.value = value[0]
        this.bigImgUrl = value[1]
      },

      handleNodeClick(e) {
        this.tableData = []
        this.imgList = []
        this.projectId = e.id
        this.getData()
      },

      downLoad(item){
        console.log(item)
        let token = util.session.get('token')
        window.open(myHttp.downloadFileDj+'?accessToken='+token+'&fileUrl='+item.fileUrl+'&fileName='+item.name)
      },
      showFile(row) {
        var that = this
        window.open(
          base.fileView + '/onlinePreview?url=' + encodeURIComponent(base.httpCtx + row.fileUrl), '_blank'
        )
      },
      isShow(item){
        this.tableDataList=JSON.parse(item)
        this.dialogVisible=true
      },
      imgChange(item){
        this.imgUrl=base.httpCtx+item
      },
      search(){
        if(this.activeName!=''){
            myHttp.getProjectSurveyBySurveyName({
            groupId:util.session.get('groupId'),
            activeName:this.activeName
          }).then(res=>{
            console.log(res)
            if(res.data.code==200){
              let list = res.data.data
              this.list=[]
              list.forEach(item=>{
                this.list.push({'label':item.surveyName,'value':item.surveyId})
              })
            }
          })
        }else{
          this.getList()
        }
      },
      getProjectSurveyBySurveyId(item){
        myHttp.getProjectSurveyBySurveyId({
          groupId:util.session.get('groupId'),
          surveyId:item
        }).then(res=>{
          console.log(res)
          if(res.data.code==200){
            let list = res.data.data
            this.tableData=list
            let keyList = ['effectDrawingImg','safetySymbolImg','masterPlanImg','temporaryElectricity']
            let nameList = {
              effectDrawingImg:'效果图地址',
              safetySymbolImg:'现场安全',
              masterPlanImg:'总平面布置图地址',
              temporaryElectricity:'现场临时用电平面布置图'
            }
            this.seleList=[]
            keyList.forEach((item,index)=>{
              if(list[item]!=''&&list[item]!=null){
                this.seleList.push({label:nameList[item],value:list[item]})
              }
            })
            console.log(this.seleList)
              this.value = this.seleList[0].label
              this.imgUrl = base.httpCtx+this.seleList[0].value
          }
        })
      },
      getList(){
        let that = this
        myHttp.getProjectSurveyByGroupId({
          groupId:util.session.get('groupId')
        }).then(res=>{
          console.log(res)
          if(res.data.code==200){
            that.list = res.data.data
            // this.getPartyBuildingActiveFileByPartybuildId(that.list[0].value)
            if(res.data.data[0].parentId==0){
              that.listItemId = false
            }else{
              if(!res.data.data[0].child){
                that.listItemId = false
              }
              that.listItemId = res.data.data[0].child[0].value
              that.getProjectSurveyBySurveyId(that.listItemId)
            }
            
            // that.currentNodekey = res.data.data[0].value
            // that.expandedkeys.push(res.data.data[0].value)
            // that.$nextTick(() => {
            //   // treeBox 元素的ref   value 绑定的node-key
            //   that.$refs.tree.setCurrentKey(that.currentNodekey)
            // })
          }
        })
      }
    }
  }
</script>

<style scoped>
.cont{
  width: 100%;
  height: 100%;
  background-color: rgb(236,240,245);
  padding: 0 24px 10px 8px;
}
.title{
  height: 4vh;
  display: flex;
  align-items: center;
}
.box{
  display: flex;
  height: 78vh;
}
.box-l{
  width: 13vw;
  border-radius: 6px;
background: #FFFFFF;
box-shadow: 0px 4px 7px 0px rgba(0, 0, 0, 0.25);
margin-right:16px ;
}
.box-l-t{
  display: flex;
  height: 4vh;
  padding: 0 16px;
  justify-content: space-between;
  align-items: center;
  border-bottom: 2px solid #ECF0F5;
}

.box-l-t>span{
  font-family: MicrosoftYaHei;
font-size: 16px;
font-weight: normal;
letter-spacing: 0em;
color: #666666;
}
.box-l-t>div{
  width: 40px;
height: 24px;
border-radius: 3px;
background: #409EFF;
font-family: MicrosoftYaHei;
font-size: 12px;
font-weight: normal;
letter-spacing: 0em;
color: #FFFFFF;
display: flex;
align-items: center;
justify-content: center;
}
.box-l-t>div:hover{
  cursor: pointer;
  opacity: 0.7;
}
.box-l-c{
  margin-top: 6px;
  height: 3vh;
  padding: 0 16px;
}
.box-l-b{
  padding-left: 16px;
  /* border: 1px solid; */
  height: 70vh;
  overflow:auto;
}
.box-r{
  border-radius: 6px;
background: #FFFFFF;
box-shadow: 5px 4px 10px -2px rgba(0, 0, 0, 0.25);
  flex: 1;
  overflow: hidden;
}
.box-r-title{
  height: 4vh;
  padding:0 1vw;
  line-height: 4vh;
  font-family: MicrosoftYaHei;
font-size: 16px;
font-weight: normal;
letter-spacing: 0em;
color: #666666;
text-align: start;
border-bottom:2px solid #ECF0F5;
margin-bottom: 1.4vh;
}
.box-r-t{
  height: 45vh;
  padding: 0 16px;
  display: flex;
  margin-bottom: 20px;
}
.box-r-t-l{
  width: 39vw;
  height: 100%;
  /* background-color: rgb(17, 24, 15); */
  overflow: hidden;
  border-radius: 6px;
  box-shadow: 5px 4px 10px -2px rgba(0, 0, 0, 0.25);
  position: relative;
}
.box-r-t-l-title{
  position: absolute;
  right: 16px;
  top: 16px;
  width: 16%;
    height: 9%;
}
.box-r-t-l-title ::v-deep .el-input__inner{
  backdrop-filter: blur(2px);
  background-color: rgba(255,255,255,0.2);
  color: #FFFFFF;
}
.box-r-b{
  height: 28vh;
  padding: 0 16px;
}
.row{
  display: flex;
}
.row>div{
  font-family: MicrosoftYaHei;
font-size: 16px;
font-weight: normal;
letter-spacing: 0em;
color: #666666;
}
.row>div:nth-child(1){
  width: 128px;
  text-align-last:justify
}
.box-r-t-r{
  padding-left:24px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.box-r-b-t{
  width: 64px;
height: 21px;
font-family: MicrosoftYaHei;
font-size: 16px;
font-weight: normal;
letter-spacing: 0em;
color: #666666;
margin-bottom: 4px;
}
.box-r-b-b{
  text-align: start;
  font-family: MicrosoftYaHei;
font-size: 14px;
font-weight: normal;
line-height: 24px;
letter-spacing: 0.1em;
color: #9E9E9E;
}
.btn{
  width: 50px;
height: 28px;
border-radius: 2px;
background: #ECF5FF;
box-sizing: border-box;
border: 1px solid #B3D8FF;
font-family: SourceHanSansCN-Normal;
font-size: 13px !important;
font-weight: 350;
color: #409EFF !important;
display: flex;
justify-content: center;
align-items: center;
}
.btn:hover{
  cursor: pointer;
  opacity: 0.7;
}
.h-flex{
  display: flex;
  justify-content: space-between;
  align-items: center;
}
::v-deep .cell{
  font-size: 14px;
}
</style>